import {useMemo, createElement} from "react";

export const UseMemo = ({next, fn, deps}) => createElement(UseMemoComp, {fn, next, deps});

const UseMemoComp = ({fn, deps, next}) => {
    return next(useMemo(fn, deps));
};
